import { UnicodeEntity } from '@mews/enums';
import { LocalizedText, useLocalizeText, useLocalizeTextOrNull } from '@mews/framework/localization';
import { Container, DropdownItem, Select } from '@optimus-web/core';
import { BusinessComponentsTextKey as TextKey } from '../../utils/BusinessComponentsTextKey';

interface CurrencySelectProps {
    currencies: {
        code: string;
        symbol: string;
    }[];
    name: string;
    onChange: (value: string) => void;
    selected: string;
    dataTestId?: string;
    portalContainerId?: string;
}

export const CurrencySelect = ({ currencies, dataTestId, onChange, ...props }: CurrencySelectProps) => {
    const localizeText = useLocalizeText();
    const localizeTextOrNull = useLocalizeTextOrNull();

    return (
        <Container minWidth="144px">
            <Select
                onChange={(_, value) => onChange(value as string)}
                data-test-id={dataTestId}
                displayMapper={(c: React.ReactElement) => c.props.value}
                inline
                label={<LocalizedText textKey={TextKey.SelectCurrency} />}
                aria-label={localizeText({ textKey: TextKey.SelectCurrency })}
                {...props}
            >
                {currencies.map(({ code, symbol }) => (
                    <DropdownItem
                        key={code}
                        label={`${code}${UnicodeEntity.NoBreakSpace}${UnicodeEntity.Dash}${UnicodeEntity.NoBreakSpace}${symbol}`}
                        value={code}
                        ariaLabel={localizeTextOrNull({ textKey: `Currency${code}` as Mews.TextKey }) ?? undefined}
                    />
                ))}
            </Select>
        </Container>
    );
};
